<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconRead">
      <path
        id="Vector"
        d="M15.3332 4.47714C15.3332 3.75446 14.7277 3.1665 13.9835 3.1665H2.01621C1.27214 3.16653 0.666762 3.75421 0.666504 4.47736V4.47758V12.5221C0.666504 13.2538 1.27815 13.8332 2.01667 13.8332H13.983C14.7365 13.8332 15.3331 13.2393 15.3331 12.5221V4.47758C15.3331 4.47752 15.3331 4.47747 15.3331 4.47741C15.3332 4.47733 15.3332 4.47725 15.3332 4.47714ZM2.01621 4.00103H13.9835C14.2538 4.00103 14.4738 4.21463 14.4738 4.47783C14.4738 4.61769 14.4022 4.74751 14.2822 4.82518L8.27212 8.71604C8.10674 8.82311 7.89299 8.82313 7.72759 8.71604C7.72759 8.71604 1.71738 4.82509 1.71749 4.82518C1.71752 4.8252 1.71741 4.82512 1.71738 4.82509C1.59747 4.74751 1.52588 4.61769 1.52588 4.47714C1.52588 4.2146 1.74585 4.00103 2.01621 4.00103ZM13.983 12.9987H2.01667C1.74915 12.9987 1.52588 12.7886 1.52588 12.5221V5.70409L7.25086 9.41034C7.47837 9.55763 7.7391 9.63126 7.99984 9.63126C8.2606 9.63126 8.52137 9.55763 8.74884 9.41034L14.4738 5.70409V12.5221C14.4738 12.7819 14.2575 12.9987 13.983 12.9987Z"
        fill="black"
      />
    </g>
  </svg>
</template>
